import React, { useState } from 'react';
import { FiPlus, FiChevronDown, FiCalendar, FiX } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { useCreateAndUpdateRotaContext } from '../contexts/createAndUpdateRotaContext';
import DatePicker from '../../../components/DatePicker';

const RotaOverview = () => {
    const { selectedDate, setSelectedDate } = useCreateAndUpdateRotaContext();
    const [showRotaMenu, setShowRotaMenu] = useState(false);

    return (
        <section className="flex items-center justify-between">
            
            {/* Left Content */}
            <div>
                <h2 className="text-2xl font-bold">
                    Rota overview
                </h2>

                <p className="text-gray-600">
                    View who is doing what and when
                </p>
            </div>


            {/* Right Actions */}
            <div className="flex items-center gap-2">

                <DatePicker
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                />


                {/* Add Rota Dropdown */}
                <div className="relative">

                    <button
                        type="button"
                        onClick={() => setShowRotaMenu(!showRotaMenu)}
                        className="
                            bg-blue-500
                            hover:bg-blue-600
                            text-white
                            py-2
                            px-3
                            rounded-lg
                            flex
                            items-center
                            gap-2
                            transition
                        "
                    >
                        <FiPlus />

                        <span>Add Rota</span>

                        <FiChevronDown
                            className={`transition-transform ${
                                showRotaMenu ? 'rotate-180' : ''
                            }`}
                        />
                    </button>


                    {/* Dropdown */}
                    {showRotaMenu && (
                        <div
                            className="
                                absolute
                                right-0
                                mt-2
                                w-60
                                bg-white
                                border
                                border-gray-200
                                rounded-xl
                                shadow-lg
                                z-50
                                overflow-hidden
                            "
                        >

                            {/* Header */}
                            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
                                <div>
                                    <p className="text-sm font-bold text-gray-900">
                                        Create Rota
                                    </p>

                                    <p className="text-[11px] text-gray-400">
                                        Choose rota type
                                    </p>
                                </div>

                                <button
                                    type="button"
                                    onClick={() => setShowRotaMenu(false)}
                                    className="text-gray-400 hover:text-gray-700"
                                >
                                    <FiX size={16} />
                                </button>
                            </div>


                            {/* Weekly Rota */}
                            <Link
                                to="/rota/add-weekly"
                                onClick={() => setShowRotaMenu(false)}
                                className="
                                    flex
                                    items-center
                                    gap-3
                                    px-4
                                    py-3
                                    hover:bg-blue-50
                                    transition
                                    group
                                "
                            >
                                <div
                                    className="
                                        w-9
                                        h-9
                                        rounded-lg
                                        bg-blue-50
                                        text-blue-600
                                        flex
                                        items-center
                                        justify-center
                                        group-hover:bg-blue-100
                                    "
                                >
                                    <FiCalendar size={17} />
                                </div>

                                <div>
                                    <p className="text-sm font-semibold text-gray-900">
                                        Weekly Rota
                                    </p>

                                    <p className="text-[11px] text-gray-500">
                                        Create a weekly staff rota
                                    </p>
                                </div>
                            </Link>


                            {/* Monthly Rota */}
                            <Link
                                to="/rota/add-monthly"
                                onClick={() => setShowRotaMenu(false)}
                                className="
                                    flex
                                    items-center
                                    gap-3
                                    px-4
                                    py-3
                                    border-t
                                    border-gray-100
                                    hover:bg-blue-50
                                    transition
                                    group
                                "
                            >
                                <div
                                    className="
                                        w-9
                                        h-9
                                        rounded-lg
                                        bg-indigo-50
                                        text-indigo-600
                                        flex
                                        items-center
                                        justify-center
                                        group-hover:bg-indigo-100
                                    "
                                >
                                    <FiCalendar size={17} />
                                </div>

                                <div>
                                    <p className="text-sm font-semibold text-gray-900">
                                        Monthly Rota
                                    </p>

                                    <p className="text-[11px] text-gray-500">
                                        Create a monthly staff rota
                                    </p>
                                </div>
                            </Link>

                        </div>
                    )}

                </div>

            </div>

        </section>
    );
};

export default RotaOverview;